<template>
  <div class="home-view painel-root-view">
    <div class="titulo painel-root-titulo">
      <div class="grid-3">
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">
            Olá, {{ primeiroNome }}
          </h2>
        </div>
        <div aria-hidden="true"></div>
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">Administração Thalamus</h2>
        </div>
      </div>
    </div>

    <div class="margem painel-root-conteudo">
      <div class="painel-chips" role="tablist" aria-label="Seções do painel">
        <button
          v-for="aba in abas"
          :key="aba.id"
          type="button"
          class="painel-chip"
          role="tab"
          :class="{ ativo: abaAtiva === aba.id }"
          :aria-selected="abaAtiva === aba.id"
          @click="selecionarAba(aba.id)"
        >
          {{ aba.label }}
        </button>
      </div>

      <div v-show="abaAtiva === 'empresas'" class="bloco margem painel-root-bloco">
        <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap">
          <div>
            <h3 class="bloco-titulo" style="margin-bottom: 0.25rem">Empresas</h3>
            <p style="color: var(--cor-fonte-fraca); margin: 0">
              {{ loadingEmpresas ? "Carregando..." : `${totalEmpresas} empresa(s) cadastrada(s)` }}
            </p>
          </div>
          <button type="button" class="acao-secundaria" @click="abrirModalCriar">
            Cadastrar empresa
          </button>
        </div>

        <p v-if="erroEmpresas" class="sem-itens" style="color: var(--cor-erro)">{{ erroEmpresas }}</p>

        <div v-if="!loadingEmpresas && empresas.length" class="painel-tabela-wrap">
          <table class="tabela">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Slug</th>
                <th style="text-align: center">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="empresa in empresas"
                :key="empresa.id"
                class="painel-linha-clicavel"
                @click="abrirEmpresa(empresa)"
              >
                <td>{{ empresa.id }}</td>
                <td>{{ empresa.nome }}</td>
                <td>{{ empresa.slug }}</td>
                <td class="alinha-centro">
                  <span class="chip" :class="empresa.ativo ? 'bg-sucesso' : 'bg-erro'">
                    {{ empresa.ativo ? "Ativa" : "Inativa" }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p v-if="!loadingEmpresas && !empresas.length && !erroEmpresas" class="sem-itens">
          Nenhuma empresa cadastrada.
        </p>
      </div>

      <div v-show="abaAtiva === 'funcionalidades'" class="bloco margem painel-root-bloco">
        <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap">
          <div>
            <h3 class="bloco-titulo" style="margin-bottom: 0.25rem">Funcionalidades</h3>
            <p style="color: var(--cor-fonte-fraca); margin: 0">
              {{
                loadingFuncionalidades
                  ? "Carregando..."
                  : `${totalFuncionalidades} funcionalidade(s) no catálogo global`
              }}
            </p>
          </div>
          <button type="button" class="acao-secundaria" @click="abrirModalCriarFuncionalidade">
            Nova funcionalidade
          </button>
        </div>

        <p v-if="erroFuncionalidades" class="sem-itens" style="color: var(--cor-erro)">
          {{ erroFuncionalidades }}
        </p>

        <div v-if="!loadingFuncionalidades && funcionalidades.length" class="painel-tabela-wrap">
          <table class="tabela">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>URL</th>
                <th style="text-align: center">Módulo</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="func in funcionalidades"
                :key="func.id"
                class="painel-linha-clicavel"
                @click="abrirModalFuncionalidade(func)"
              >
                <td>{{ func.id }}</td>
                <td>{{ func.nome }}</td>
                <td>{{ Number(func.modulo) === 1 ? (func.URL || "—") : "—" }}</td>
                <td class="alinha-centro">
                  <span class="chip" :class="Number(func.modulo) === 1 ? 'bg-sucesso' : 'bg-cinza'">
                    {{ Number(func.modulo) === 1 ? "Sim" : "Não" }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p
          v-if="!loadingFuncionalidades && !funcionalidades.length && !erroFuncionalidades"
          class="sem-itens"
        >
          Nenhuma funcionalidade cadastrada.
        </p>
      </div>
    </div>

    <Teleport to="body">
      <div v-if="modalAberto" class="modal-mask" @click.self="fecharModal">
        <div class="jm margem" style="min-width: min(520px, 92vw)" role="dialog" aria-modal="true">
          <h2>Cadastrar empresa</h2>
          <form class="grid-1" @submit.prevent="salvar">
            <div>
              <label>Nome</label>
              <input v-model="form.nome" type="text" class="input" required placeholder="Nome da empresa" />
            </div>
            <div>
              <label>Slug</label>
              <input
                v-model="form.slug"
                type="text"
                class="input"
                placeholder="ex.: roboflex (opcional no cadastro)"
              />
            </div>
            <div>
              <label class="alinha-v" style="gap: 0.5rem">
                <input v-model="form.ativo" type="checkbox" />
                Empresa ativa
              </label>
            </div>
          </form>
          <div class="submit direita">
            <button type="button" class="acao-secundaria" @click="fecharModal" :disabled="salvando">
              Cancelar
            </button>
            <button type="button" @click="salvar" :disabled="salvando || !form.nome">
              {{ salvando ? "Salvando..." : "Salvar" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <div v-if="modalFuncionalidadeAberto" class="modal-mask" @click.self="fecharModalFuncionalidade">
        <div class="jm margem" style="min-width: min(560px, 94vw)" role="dialog" aria-modal="true">
          <h2>{{ formFunc.id ? `Editar funcionalidade #${formFunc.id}` : "Nova funcionalidade" }}</h2>
          <form class="grid-1" @submit.prevent="salvarFuncionalidade">
            <div>
              <label>Nome</label>
              <input v-model="formFunc.nome" type="text" class="input" required />
            </div>
            <div class="grid-2">
              <label class="alinha-v" style="gap: 0.5rem">
                <input v-model="formFunc.modulo" type="checkbox" :true-value="1" :false-value="0" />
                Card na home (módulo)
              </label>
            </div>
            <div v-if="Number(formFunc.modulo) === 1">
              <label>URL</label>
              <input
                v-model="formFunc.URL"
                type="text"
                class="input"
                required
                placeholder="/caminho ou URL"
              />
            </div>
            <div v-if="Number(formFunc.modulo) === 1">
              <label>Imagem do card (caminho_img)</label>
              <input
                v-model="formFunc.caminho_img"
                type="text"
                class="input"
                placeholder="ex.: injetora.jpg"
              />
            </div>
          </form>
          <div class="submit direita">
            <button
              type="button"
              class="acao-secundaria"
              @click="fecharModalFuncionalidade"
              :disabled="salvandoFunc"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="salvarFuncionalidade"
              :disabled="salvandoFunc || !formFunc.nome || (Number(formFunc.modulo) === 1 && !formFunc.URL?.trim())"
            >
              {{ salvandoFunc ? "Salvando..." : "Salvar" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import { createToaster } from "@meforma/vue-toaster";
import empresaRootService from "@/services/empresaRootService";

const toaster = createToaster({ position: "top-right", duration: 4000 });

function formVazio() {
  return {
    id: null,
    nome: "",
    slug: "",
    ativo: true,
  };
}

function formFuncVazio() {
  return {
    id: null,
    nome: "",
    URL: "",
    modulo: 0,
    caminho_img: "",
  };
}

export default {
  name: "PainelRootView",
  data() {
    return {
      usuarioLogado: sso.getUsuarioLogado() || { nome: "Root" },
      abaAtiva: "empresas",
      abas: [
        { id: "empresas", label: "Empresas" },
        { id: "funcionalidades", label: "Funcionalidades" },
      ],
      empresas: [],
      funcionalidades: [],
      loadingEmpresas: true,
      loadingFuncionalidades: false,
      funcionalidadesCarregadas: false,
      erroEmpresas: "",
      erroFuncionalidades: "",
      modalAberto: false,
      modalFuncionalidadeAberto: false,
      salvando: false,
      salvandoFunc: false,
      form: formVazio(),
      formFunc: formFuncVazio(),
    };
  },
  computed: {
    primeiroNome() {
      const nome = this.usuarioLogado?.nome || "Root";
      return String(nome).split(" ")[0];
    },
    totalEmpresas() {
      return this.empresas.length;
    },
    totalFuncionalidades() {
      return this.funcionalidades.length;
    },
  },
  async created() {
    await this.carregarEmpresas();
  },
  methods: {
    async selecionarAba(id) {
      this.abaAtiva = id;
      if (id === "funcionalidades" && !this.funcionalidadesCarregadas) {
        await this.carregarFuncionalidades();
      }
    },
    async carregarEmpresas() {
      this.loadingEmpresas = true;
      this.erroEmpresas = "";
      try {
        const data = await empresaRootService.listar();
        this.empresas = Array.isArray(data) ? data : [];
      } catch (e) {
        this.erroEmpresas =
          e.response?.status === 403
            ? "Acesso restrito ao usuário root."
            : "Não foi possível carregar as empresas.";
        this.empresas = [];
      } finally {
        this.loadingEmpresas = false;
      }
    },
    async carregarFuncionalidades() {
      this.loadingFuncionalidades = true;
      this.erroFuncionalidades = "";
      try {
        const data = await empresaRootService.listarFuncionalidades();
        this.funcionalidades = Array.isArray(data) ? data : [];
        this.funcionalidadesCarregadas = true;
      } catch (e) {
        this.erroFuncionalidades =
          e.response?.status === 403
            ? "Acesso restrito ao usuário root."
            : "Não foi possível carregar as funcionalidades.";
        this.funcionalidades = [];
      } finally {
        this.loadingFuncionalidades = false;
      }
    },
    abrirModalCriar() {
      this.form = formVazio();
      this.modalAberto = true;
    },
    abrirEmpresa(empresa) {
      this.$router.push({ name: "painelRootEmpresa", params: { id: empresa.id } });
    },
    fecharModal() {
      if (this.salvando) return;
      this.modalAberto = false;
      this.form = formVazio();
    },
    abrirModalCriarFuncionalidade() {
      this.formFunc = formFuncVazio();
      this.modalFuncionalidadeAberto = true;
    },
    abrirModalFuncionalidade(func) {
      this.formFunc = {
        id: func.id,
        nome: func.nome || "",
        URL: func.URL || "",
        modulo: Number(func.modulo) === 1 ? 1 : 0,
        caminho_img: func.caminho_img || "",
      };
      this.modalFuncionalidadeAberto = true;
    },
    fecharModalFuncionalidade() {
      if (this.salvandoFunc) return;
      this.modalFuncionalidadeAberto = false;
      this.formFunc = formFuncVazio();
    },
    async salvar() {
      if (!this.form.nome?.trim()) return;
      this.salvando = true;
      try {
        await empresaRootService.criar({
          nome: this.form.nome.trim(),
          slug: this.form.slug?.trim() || undefined,
          ativo: !!this.form.ativo,
        });
        toaster.show("Empresa cadastrada.", { type: "success" });
        this.modalAberto = false;
        this.form = formVazio();
        await this.carregarEmpresas();
      } catch (e) {
        const msg =
          e.response?.data?.message ||
          e.response?.data?.errors?.slug?.[0] ||
          e.response?.data?.errors?.nome?.[0] ||
          "Falha ao salvar empresa.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvando = false;
      }
    },
    async salvarFuncionalidade() {
      if (!this.formFunc.nome?.trim()) return;
      const ehModulo = Number(this.formFunc.modulo) === 1;
      if (ehModulo && !this.formFunc.URL?.trim()) {
        toaster.show("URL é obrigatória para funcionalidades marcadas como módulo.", {
          type: "error",
        });
        return;
      }
      this.salvandoFunc = true;
      try {
        const payload = {
          nome: this.formFunc.nome.trim(),
          URL: ehModulo ? this.formFunc.URL.trim() : null,
          modulo: ehModulo ? 1 : 0,
          caminho_img: ehModulo ? this.formFunc.caminho_img?.trim() || null : null,
        };
        if (this.formFunc.id) {
          const atualizado = await empresaRootService.atualizarFuncionalidade(
            this.formFunc.id,
            payload
          );
          const idx = this.funcionalidades.findIndex((f) => f.id === this.formFunc.id);
          if (idx >= 0) {
            this.funcionalidades.splice(idx, 1, { ...this.funcionalidades[idx], ...atualizado });
          }
          toaster.show("Funcionalidade atualizada.", { type: "success" });
        } else {
          const criada = await empresaRootService.criarFuncionalidade(payload);
          this.funcionalidades.push(criada);
          this.funcionalidades.sort((a, b) => Number(a.id) - Number(b.id));
          toaster.show("Funcionalidade criada.", { type: "success" });
        }
        this.modalFuncionalidadeAberto = false;
        this.formFunc = formFuncVazio();
      } catch (e) {
        const errors = e.response?.data?.errors;
        const msg =
          e.response?.data?.message ||
          (errors && Object.values(errors).flat()[0]) ||
          "Falha ao salvar funcionalidade.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvandoFunc = false;
      }
    },
  },
};
</script>

<style scoped>
.painel-root-view {
  display: flex;
  flex-direction: column;
  overflow: visible;
  width: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}

.painel-root-titulo {
  flex-shrink: 0;
  margin-top: 2rem;
}

.painel-root-conteudo {
  display: flex;
  flex-direction: column;
  overflow: visible;
  padding-bottom: 2rem;
}

.painel-root-bloco {
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.painel-tabela-wrap {
  margin-top: 1rem;
  overflow-x: auto;
  overflow-y: visible;
}

.painel-tabela-wrap .tabela {
  width: max-content;
  min-width: 100%;
}

.painel-chips {
  flex-shrink: 0;
  display: inline-flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 3px;
  border-radius: 10px;
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--cor-separador);
}

.painel-chip {
  border: none;
  background: transparent;
  color: var(--cor-fonte);
  padding: 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.painel-chip:hover:not(.ativo) {
  color: var(--cor-fonte-forte);
  background: rgba(255, 255, 255, 0.5);
}

.painel-chip.ativo {
  background: var(--cor-primaria);
  color: var(--cor-bg);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.painel-linha-clicavel {
  cursor: pointer;
}

.painel-linha-clicavel:hover td {
  background: rgba(0, 0, 0, 0.03);
}
</style>
